module.exports = __webpack_public_path__ + "img/82efc9b1e7aa42bb43b8154b379fe831.9de23f7b.png";